export function calculateReadingTime(text: string) {
  // Define the average reading speed (words per minute)
  const averageReadingSpeed = 200; // words per minute

  // Split the text into words and count the number of words
  const wordCount = text.split(/\s+/).length;

  // Calculate the reading time in minutes
  const readingTimeMinutes = Math.round(wordCount / averageReadingSpeed);

  // Return the reading time in minutes
  return readingTimeMinutes;
}

export function formatDate(date = new Date()) {
  // Define options for the date format
  const options = {
    day: "numeric", // Numeric day of the month
    month: "long", // Full name of the month
    year: "numeric", // Numeric year
  };

  // Create a new Intl.DateTimeFormat object with the specified options
  const formatter = new Intl.DateTimeFormat("en-US", options);

  // Format the date
  const formattedDate = formatter.format(new Date(date));

  // Return the formatted date
  return formattedDate;
}
// TODO: Remove the following function after the refactor
// export function generateHTMLTOC(markdown: string) {
//   const headers = markdown.match(/^#{1,6} .+$/gm);
//   if (!headers) return "";
//
//   const toc = headers.map((header) => {
//     const level = header.match(/^#+/)[0].length;
//     const text = header.replace(/^#+\s*/, "").trim();
//     const anchor = text.toLowerCase().replace(/[^\w]+/g, "-");
//     return { level, text, anchor };
//   });
//
//   let htmlTOC = "";
//   let previousLevel = 0;
//
//   toc.forEach((item) => {
//     const { level, text, anchor } = item;
//
//     if (level > previousLevel) {
//       for (let i = previousLevel; i < level; i++) {
//         htmlTOC += "<ol>";
//       }
//     } else if (level < previousLevel) {
//       for (let i = previousLevel; i > level; i--) {
//         htmlTOC += "</ol>";
//       }
//     }
//
//     // htmlTOC += `<li><a href="#${anchor}">${text}</a></li>`;
//     htmlTOC += `<li>${text}</li>`;
//     previousLevel = level;
//   });
//
//   // Close remaining open tags
//   for (let i = previousLevel; i > 0; i--) {
//     htmlTOC += "</ol>";
//   }
//
//   return htmlTOC;
// }

function removeNumbersAndMarkdownSigns(text: string): string {
  // Regular expression to match numbers and markdown signs
  const regex = /[0-9#*_.\-~`]/g;
  // Replace the matched characters with an empty string
  return text.replace(regex, "");
}

export function generateHTMLTOC(markdown: string) {
  const headers = markdown.match(/^#{2,6} .+$/gm);
  if (!headers) return "";

  let htmlTOC = "<ol>"; // Start with an opening <ol> tag
  let previousLevel = 0;

  headers.forEach((header, index) => {
    const level = header.match(/^#+/)[0].length;
    const text = removeNumbersAndMarkdownSigns(
      header.replace(/^#+\s*/, "").trim(),
    );
    const anchor = text.toLowerCase().replace(/[^\w]+/g, "-");

    if (index === 0) {
      previousLevel = level; // Set the first header's level as the initial level
    }

    if (level > previousLevel) {
      for (let i = previousLevel; i < level; i++) {
        htmlTOC += "<ol>";
      }
    } else if (level < previousLevel) {
      for (let i = previousLevel; i > level; i--) {
        htmlTOC += "</ol>";
      }
    }

    htmlTOC += `<li>- ${text}</li>`; // Use the anchor in the href attribute if needed
    previousLevel = level;
  });

  htmlTOC += "</ol>"; // Close the initial <ol> tag

  return htmlTOC;
}
